import { useState, FC } from 'react';
import { useEffectCancelled } from '@wajeez-web/components/helpers';
import { CommonTableProps } from './Types';
import { Table, TableColumnsType } from 'antd';

interface PaginatedTableProps extends CommonTableProps {
  columns: TableColumnsType<any>;
}

const DefaultTable: FC<PaginatedTableProps> = ({
  getDataAction,
  columns,
  refresh,
  setRefresh,
}) => {
  const [data, setData] = useState<
    {
      [key: string]: string;
    }[]
  >([]);
  const [loading, setLoading] = useState(false);

  useEffectCancelled(
    (canceller) => () => {
      getData(canceller);
    },
    [getDataAction]
  );

  useEffectCancelled(
    (canceller) => () => {
      if (refresh) {
        getData(canceller);
        setRefresh && setRefresh();
      }
    },
    [refresh]
  );

  const getData = (canceller: AbortController) => {
    // setNewAdd('')
    setLoading(true);
    getDataAction(canceller)
      .then((res) => {
        setData(res.data);
      })
      .then(() => {
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  return (
    <div>
      <Table loading={loading} columns={columns} dataSource={data} />
    </div>
  );
};

export default DefaultTable;
